import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { CircleAlert, Trash2 } from "lucide-react"

interface ConfirmDialogProps {
  isOpen: boolean
  text: string
  onClose: () => void
  onConfirm: () => void
}

const ConfirmDialog = ({ isOpen, onClose, onConfirm, text }: ConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CircleAlert className="h-5 w-5 text-destructive" />
            Confirmation
          </DialogTitle>
          <DialogDescription>{text}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:justify-between">
          <Button variant="ghost" onClick={onClose} data-testid="confirm-dialog-cancel">
            {t("cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm} data-testid="confirm-dialog-confirm">
            <Trash2 className="mr-2 h-4 w-4" />
            {t("confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDialog
